import { Box, Button, Typography } from "@mui/material";

import TrackingSystemSettings from "./TrackingSystemSettings";
import { useContext, useEffect, useState } from "react";
import { Http, appLogger } from "../../utils";
import { useNavigate, useParams } from "react-router-dom";
import { UserLoginInfo } from "../../types/context";
import { UserContext } from "../../context/userContext";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import {
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  FEEDBACK_TYPE_FEEDBACK,
} from "../../model";

const ZendeskSettings = ({
  snackbarShowMessage,
}: {
  snackbarShowMessage: any;
}) => {
  const { productId, versionId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [productParams, setProductParams] = useState<any | null>(null);
  const { userInfo } = useContext(UserContext) as UserLoginInfo;

  const handleFetchProduct = () => {
    setLoading(true);
    Http.get({
      url: `/api/v2/products/${productId}/${versionId}`,
      state: userInfo,
    })
      .then((response: any) => {
        setLoading(false);
        appLogger.info({
          infoObj: {
            method: "useEffect",
            component: "add-products",
            fileName: "index.tsx",
            productResponse: response,
          },
        });
        // const tempProduct = checkAndSetDefaultValues(response.products[0]);
        // if (location && location.state && location.state.cloneNewProduct) {
        //   response.products[0].id = "";
        //   response.products[0].version = "";
        //   response.products[0].name = "";
        //   response.products[0].apiKey = "";
        // } else if (
        //   location &&
        //   location.state &&
        //   location.state.cloneNewVersion
        // ) {
        //   response.products[0].version = "";
        //   response.products[0].apiKey = "";
        //   response.products[0].cloneNewVersion = true;
        // }
        setProductParams(response);
      })
      .catch((error: any) => {
        appLogger.error({
          errObj: {
            method: "useEffect",
            component: "add-products",
            fileName: "index.tsx",
            err: error,
          },
        });

        snackbarShowMessage("products fetch error", "error", 3000);
      });
  };

  useEffect(() => {
    if (productId && versionId) {
      handleFetchProduct();
    }
  }, [productId, versionId]);

  const handleMandatoryValidation = (settings: any) => {
    if (settings && settings.configs) {
      if (
        settings.configs[FEEDBACK_TYPE_FEEDBACK]?.url ||
        settings.configs[FEEDBACK_TYPE_FEEDBACK]?.auth?.authKey ||
        settings.configs[FEEDBACK_TYPE_FEEDBACK]?.auth?.authUser
      ) {
        return mandatoryCheck(settings.configs[FEEDBACK_TYPE_FEEDBACK]);
      }
      if (
        settings.configs[FEEDBACK_TYPE_BUGS]?.url ||
        settings.configs[FEEDBACK_TYPE_BUGS]?.auth?.authKey ||
        settings.configs[FEEDBACK_TYPE_BUGS]?.auth?.authUser
      ) {
        return mandatoryCheck(settings.configs[FEEDBACK_TYPE_BUGS]);
      }
      if (
        settings.configs[FEEDBACK_TYPE_FEATURE_REQ]?.url ||
        settings.configs[FEEDBACK_TYPE_FEATURE_REQ]?.auth?.authKey ||
        settings.configs[FEEDBACK_TYPE_FEATURE_REQ]?.auth?.authUser
      ) {
        return mandatoryCheck(settings.configs[FEEDBACK_TYPE_FEATURE_REQ]);
      }
    }
    return true;
  };

  const mandatoryCheck = (settings: any) => {
    if (
      !(settings?.url && settings?.auth?.authKey && settings?.auth?.authUser)
    ) {
      snackbarShowMessage(
        "You must provide tracking system url, auth user and auth key",
        "error",
        3000
      );
      return false;
    }
    return true;
  };

  const handleSave = () => {
    if (
      handleMandatoryValidation(productParams?.products[0]?.zendeskSettings)
    ) {
      const postData = productParams;
      setLoading(true);
      appLogger.info(
        {
          infoObj: {
            method: "putUpdate",
            component: "add-products",
            fileName: "index.tsx",
            productParams: postData,
          },
        },
        "Update product"
      );
      Http.put({
        url: `/api/v2/products`,
        body: {
          ...postData,
        },
        state: userInfo,
      })
        .then((response: any) => {
          setLoading(false);
          if (response && response.message === "Product already exists") {
            snackbarShowMessage("Product already exists", "error", 3000);
          } else {
            snackbarShowMessage("product saved successfully", "success", 3000);
            // setTimeout(() => {
            //   navigate(-1);
            // }, 2000);
          }
        })
        .catch((error: any) => {
          appLogger.error({
            errObj: {
              method: "putUpdate",
              component: "add-products",
              fileName: "index.tsx",
              err: error,
            },
          });
          setLoading(false);
          snackbarShowMessage(error.message, "error");
        });
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className={loading ? "add-products-wrap loader" : "add-products-wrap"}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          justifyContent: "space-between",
          padding: "0 20px",
        }}
      >
        <Box display="flex" flexDirection="column" justifyContent="end">
          <Typography
            sx={{
              borderBottom: "2px solid #0157FF",
              color: "#0157FF",
              fontFamily: "Poppins",
              fontSize: "14px",
              padding: "12px 0",
              lineHeight: "24px",
              fontWeight: 500,
            }}
          >
            Configure Zendesk
          </Typography>
        </Box>
        <Box>
          <Button
            type="button"
            variant="outlined"
            sx={{ textTransform: "uppercase" }}
            onClick={handleCancel}
            className="create-pro-btn "
            id="pro-cancel"
          >
            close
          </Button>

          <Button
            type="submit"
            variant="contained"
            sx={{ textTransform: "uppercase" }}
            onClick={handleSave}
            className="create-pro-btn guideTourCreateSave"
            id="pro-save"
          >
            {productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].id
              ? "save"
              : "create"}
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          padding: "30px",
          overflowX: "auto",
        }}
      >
        <TrackingSystemSettings
          productParams={productParams}
          setProductParams={setProductParams}
        />
      </Box>
    </div>
  );
};

export default withSnackbar(ZendeskSettings);
